<template>
    <div>

      <v-layout row wrap>
        <v-toolbar  size="120px" dark color="info">
          <v-toolbar-title >Banka Pos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

          <a target="_self" v-bind:href="'#/parametreler/genel/bankapos/yeni'">
            <v-btn hidden="xs" flat> Banka Pos Ekle
            </v-btn>
          </a>
          <v-icon right dark>add_box</v-icon>

        </v-toolbar>
      </v-layout>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
          <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Git(props.item.PosKodu)" item>
              <td class="text-xs-left">{{ props.item.BankaPosID }}</td>
              <td class="text-xs-left">{{ props.item.Aciklama }}</td>
              <td class="text-xs-left">{{ props.item.PosKodu }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Banka Pos Id',
            value: 'BankaPosID'
          },
          {
            text: 'Açıklama',
            value: 'Aciklama'
          },
          {
            text: 'Pos Kodu',
            value: 'PosKodu'
          }
        ],
        loading: false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        progress:false,
        dialog: false,
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            bankakod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            bankaadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Git(v) {
        if (v != null) {
          var url = '#/parametreler/genel/bankapos/' + v
          window.open(url, '_target')
        }
      }
    },
    beforeMount: beforeMount
  }



  function beforeMount() {
    this.progress=true

 var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = {
      CompanyCode:credentials.SirketKodu,
}

    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress=false
    }, (response) => {
      if (response.status === 0) {
this.text1 = 'Service Unavailable'
this.progress=false
              this.snackbar = true
               } else {
this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress=false        }
    })
  }



</script>

<style>

</style>